<template>
    <nav class="bottom-navbar fixed-bottom text-center">
        <div class="row">
            <div class="col">
                <router-link to="/"><i class="fa-solid fa-dollar-sign"></i><br/>현재가</router-link>
            </div>
            <div class="col">
                <router-link to="/investProgress"><i class="fa-solid fa-money-bill-trend-up"></i><br/>투자</router-link>
            </div>
            <div class="col">
                <router-link to="/alarm"><i class="fa-solid fa-bell"></i><br/>알람</router-link>
            </div>
            <div class="col">
                <router-link to="/calendar"><i class="fas fa-calendar-alt"></i><br/>캘린더</router-link>
            </div>
        </div>
    </nav>
</template>

<script>
    export default {

    }
</script>

<style>

</style>